import { useMemo } from "react";
import { useGetFoldersQuery } from "@/shared/services";
import type { IStoriesFolder } from "@/shared/types";

export type TFolderWithChildren = IStoriesFolder & {
  children: TFolderWithChildren[];
};

export const useGetFolders = () => {
  const { data, isLoading } = useGetFoldersQuery();

  const folders = useMemo(() => {
    if (!data) return [];

    const buildNestedStructure = (
      allFolders: IStoriesFolder[],
      parentId: string | null | undefined,
    ): TFolderWithChildren[] => {
      return allFolders
        .filter((folder: IStoriesFolder) => {
          if (parentId === undefined) {
            return folder.parentId === null || folder.parentId === undefined;
          }
          return folder.parentId === parentId;
        })
        .map((folder: IStoriesFolder) => ({
          ...folder,
          children: buildNestedStructure(allFolders, folder._id),
        }));
    };

    return buildNestedStructure(data, undefined);
  }, [data]);

  return { folders, isLoading };
};
